import { Pump } from '../../domain/model/pump';
import { AxiosResponse, AxiosInstance, AxiosError } from 'axios';
import Handler from '@/core/domain/usecase/handler';

export interface DeletePumpRepository {
    (id: number): Promise<Pump>
}

const deletePumpRepository = (axios: AxiosInstance): DeletePumpRepository => async (id: number) => {
    try {
        const response: AxiosResponse = await axios.delete(`/pump/${id}`)

        const pump: Pump = response.data
        return pump
    } catch (err: any | AxiosError) {
        if (err.isAxiosError) {
            throw new Handler().trataErro(err)
        } else {
            throw err
        }
    }
}

export default deletePumpRepository